import type { ClassMember } from '@wx-weiqi/contracts';

function normalizedSearchText(value: string): string {
  return value.trim().toLocaleLowerCase('zh-CN');
}

export function filterGuidedGameStudents(
  students: readonly Pick<ClassMember, 'membership' | 'status'>[],
  keyword: string,
): readonly Pick<ClassMember, 'membership' | 'status'>[] {
  const normalizedKeyword = normalizedSearchText(keyword);
  const activeStudents = students.filter(
    (student) =>
      student.status === 'ACTIVE' &&
      student.membership.role === 'STUDENT' &&
      student.membership.status === 'ACTIVE' &&
      student.membership.user.status === 'ACTIVE',
  );
  if (normalizedKeyword.length === 0) return activeStudents;

  return activeStudents.filter((student) =>
    normalizedSearchText(student.membership.user.displayName).startsWith(normalizedKeyword),
  );
}
